import type { SupportedLanguage } from './index'

export const localizedRoutes = {
  home: '',
  about: 'about',
  processes: 'processes',
  innovation: 'innovation',
  products: 'products',
  sectors: 'sectors',
  sustainability: 'sustainability',
  contacts: 'contacts',
  privacy: 'privacy',
} as const

export type RouteKey = keyof typeof localizedRoutes

export function getLocalizedPath(routeKey: RouteKey, lang: SupportedLanguage): string {
  const slug = localizedRoutes[routeKey]
  return slug ? `/${lang}/${slug}` : `/${lang}`
}

export function findRouteKeyFromSlug(slug: string): RouteKey | null {
  for (const [key, route] of Object.entries(localizedRoutes)) {
    if (route === slug) {
      return key as RouteKey
    }
  }
  return null
}
